import { createAction } from "redux-act";
export var setLocale = createAction("SET_LOCALE");
